import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/jobs/constants';
import { jobsQueryKeys } from '@/modules/jobs/queries/queryKeys';
import type { SubmissionDecisionModeApi } from '@/modules/jobs/types';
import { invalidateQuery } from '@/utils/queries';

interface SubmissionDecisionModeParams {
  jobId: string;
  mode: SubmissionDecisionModeApi;
}

export const useSubmissionDecisionModeMutation = () => {
  return useMutation({
    mutationFn: async ({ jobId, mode }: SubmissionDecisionModeParams) => {
      const { data } = await fetchClient.PUT(endpoints.submissionDecisionMode, {
        params: { path: { id: jobId } },
        body: { mode },
      });

      return data;
    },
    // Only job caches are invalidated: the API persists the new mode without
    // reconciling candidates already in the pipeline, so there is nothing on
    // existing candidate queries for this to invalidate.
    onSettled: (_data, _error, { jobId }) => {
      invalidateQuery(jobsQueryKeys.detail(jobId))();
      invalidateQuery(jobsQueryKeys.lists())();
    },
  });
};
